(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "lodash/map", "..", "../../../../core/ua", "../../util"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("lodash/map"), require(".."), require("../../../../core/ua"), require("../../util"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global.map, global._, global.ua, global.util);
    global.Share = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _asyncToGenerator2, _map, _, _ua, _util) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports["default"] = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _map = _interopRequireDefault(_map);

  var ShareDirectiveProcessor = /*#__PURE__*/function () {
    function ShareDirectiveProcessor() {
      this.name = "share";
      this.unmounting = false;
      this.isDisabled = true;
    }

    var _proto = ShareDirectiveProcessor.prototype;

    _proto.callback = function callback(sdk, directive, context) {
      var _this = this;

      if (context.unmount) {
        return this.disable(sdk, directive);
      }

      if (directive.args.disable) {
        return this.disable(sdk, directive);
      } // return this.enable(sdk, directive).then(() => {
      //   return this.mount(sdk, directive);
      // });


      return this.mount(sdk, directive).then(function () {})["finally"](function () {
        // 无论分享是否OK，都开启分享。
        // 一些公司没有认证，无法自定义分享，但是他们要求开启分享菜单。
        _this.enable(sdk, directive);
      });
    };

    _proto.enable = /*#__PURE__*/function () {
      var _enable = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(sdk, directive) {
        var _this2 = this;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isDisabled) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_ua.isWxwork) {
                  _context.next = 6;
                  break;
                }

                sdk.run("showMenuItems", {
                  menuList: _.WX_MENU_SOCIAL
                });
                this.isDisabled = false;
                return _context.abrupt("return");

              case 6:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  sdk[directive.args.immediate ? "run" : "exec"]("showMenuItems", {
                    menuList: _.WX_MENU_SOCIAL,
                    success: function success() {
                      resolve(undefined);
                      _this2.isDisabled = false;
                    },
                    fail: function fail(err) {
                      reject(new Error((0, _util.getWxErrMsg)(err) || "wx error"));
                    }
                  });
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function enable(_x, _x2) {
        return _enable.apply(this, arguments);
      }

      return enable;
    }();

    _proto.disable = /*#__PURE__*/function () {
      var _disable = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(sdk, directive) {
        var _this3 = this;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sdk.run("internal:reset");

                if (_ua.isWxwork) {
                  _context2.next = 5;
                  break;
                }

                sdk.run("hideMenuItems", {
                  menuList: _.WX_MENU_SOCIAL
                });
                this.isDisabled = true;
                return _context2.abrupt("return");

              case 5:
                return _context2.abrupt("return", new Promise(function (resolve) {
                  // 隐藏直接同步调用，如果 sdk 没 ready，直接忽略即可.
                  sdk.exec("hideMenuItems", {
                    menuList: _.WX_MENU_SOCIAL,
                    success: function success() {
                      _this3.isDisabled = true;
                      resolve(undefined);
                    },
                    fail: function fail(err) {
                      console.log("hideMenuItems:fail", err);
                      resolve(undefined); // reject(new Error(getWxErrMsg(err) || "wx error"));
                    }
                  });
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disable(_x3, _x4) {
        return _disable.apply(this, arguments);
      }

      return disable;
    }();

    _proto.mount = /*#__PURE__*/function () {
      var _mount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(sdk, directive) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  var p = (0, _map["default"])(_.ShareChannels, function (channel) {
                    return sdk.exec(channel.method, directive.option);
                  });
                  Promise.all(p).then(function () {
                    resolve(undefined);
                  })["catch"](function (err) {
                    // eslint-disable-next-line
                    reject(err);
                  });
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function mount(_x5, _x6) {
        return _mount.apply(this, arguments);
      }

      return mount;
    }();

    return ShareDirectiveProcessor;
  }();

  _exports["default"] = ShareDirectiveProcessor;
});
//# sourceMappingURL=Share.js.map